import { render, staticRenderFns } from "./ModalFirmantes.vue?vue&type=template&id=006e33e5&scoped=true&"
import script from "./ModalFirmantes.vue?vue&type=script&lang=js&"
export * from "./ModalFirmantes.vue?vue&type=script&lang=js&"
import style0 from "./ModalFirmantes.vue?vue&type=style&index=0&id=006e33e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e33e5",
  null
  
)

export default component.exports